import { Layer } from "ol/layer";
import { CameraFeature, CameraHandler } from ".";
import WebGLPointsLayer from "ol/layer/WebGLPoints";
import VectorSource from "ol/source/Vector";

const minCameraRadius = 1.5;
const maxCameraRadius = 6;

export class AerialCameras {
  private cameraHandler: CameraHandler;
  public mapSource: VectorSource;
  private mapLayer: WebGLPointsLayer<any>;

  constructor(cameraHandler: CameraHandler) {
    this.cameraHandler = cameraHandler;

    this.mapSource = new VectorSource({
      wrapX: false
    });

    const backgroundLayer = new WebGLPointsLayer({
      zIndex: 1,
      source: this.mapSource,
      style: {
        filter: ['>', ['get', 'visible'], 0.5],
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10, minCameraRadius,
          18, maxCameraRadius
        ],
        "circle-fill-color": "#000000"
      }
    });

    const foregroundLayer = new WebGLPointsLayer({
      zIndex: 1,
      source: this.mapSource,
      style: {
        filter: ['>', ['get', 'visible'], 0.5],
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10, minCameraRadius - 1,
          18, maxCameraRadius - 1
        ],
        "circle-fill-color": "#ffffff"
      }
    });

    this.mapLayer = backgroundLayer;
    this.map.addLayer(backgroundLayer);
    this.map.addLayer(foregroundLayer);
  }

  get viewer() {
    return this.cameraHandler.viewer;
  }

  get files() {
    return this.cameraHandler.files;
  }

  get map() {
    return this.cameraHandler.map;
  }

  getFeatureForEvent(event) {
    try {
      const features = this.map.getFeaturesAtPixel(event.pixel, {
        layerFilter: (layer: Layer) => layer === this.mapLayer
      }) as CameraFeature[];

      // Only return the first feature
      return features.slice(0,1);
    } catch {
      return [];
    }
  }
}